// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQ_block__aO1m3 {
	width: 100%;
	padding: 6.25rem 10.31rem;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
}

.FAQ_accordion__item__IGLZY {
	color: var(--accent-color, #956446);
	font-family: 'Noto Sans';
	font-size: 1.375rem;
	font-style: normal;
	font-weight: 500;
	line-height: 160%; /* 2.2rem */

	border-color: #956446;

	padding: 1rem;
	flex: 1 1;
	text-align: left;
}

.FAQ_accordion__text__qRT5l {
	margin-left: 1rem;
	color: var(--accent-color, #956446);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.FAQ_text__block__2PdcG {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
}

.FAQ_text__box__IsJ2P {
	width: 45%;
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

.FAQ_block__title__h-qpo {
	color: var(--accent-color, #956446);

	/* text small bold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 160%; /* 1.6rem */
}

@media (max-width: 1280px) {
	.FAQ_block__aO1m3 {
		padding: 6.25rem 5rem;
	}
}

@media (max-width: 460px) {
	.FAQ_block__aO1m3 {
		flex-direction: column;
		padding: 4.38rem 1.25rem;
		align-items: center;
	}
	.FAQ_accordion__text__qRT5l {
		flex-direction: column;
	}
	.FAQ_text__box__IsJ2P {
		width: 100%;
	}
	.FAQ_text__block__2PdcG {
		width: 100%;
	}

	.FAQ_accordion__item__IGLZY {
		padding: 0.5rem 1rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/FAQ/FAQ.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,mCAAmC;CACnC,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,qBAAqB;;CAErB,aAAa;CACb,SAAO;CACP,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,aAAa;CACb,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,mCAAmC;;CAEnC,oBAAoB;CACpB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;CACpB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;;CAEA;EACC,oBAAoB;CACrB;AACD","sourcesContent":[".block {\n\twidth: 100%;\n\tpadding: 6.25rem 10.31rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 3.2rem;\n}\n\n.accordion__item {\n\tcolor: var(--accent-color, #956446);\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.375rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 160%; /* 2.2rem */\n\n\tborder-color: #956446;\n\n\tpadding: 1rem;\n\tflex: 1;\n\ttext-align: left;\n}\n\n.accordion__text {\n\tmargin-left: 1rem;\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.text__block {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.3rem;\n}\n\n.text__box {\n\twidth: 45%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.25rem;\n}\n\n.block__title {\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small bold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 160%; /* 1.6rem */\n}\n\n@media (max-width: 1280px) {\n\t.block {\n\t\tpadding: 6.25rem 5rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.block {\n\t\tflex-direction: column;\n\t\tpadding: 4.38rem 1.25rem;\n\t\talign-items: center;\n\t}\n\t.accordion__text {\n\t\tflex-direction: column;\n\t}\n\t.text__box {\n\t\twidth: 100%;\n\t}\n\t.text__block {\n\t\twidth: 100%;\n\t}\n\n\t.accordion__item {\n\t\tpadding: 0.5rem 1rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `FAQ_block__aO1m3`,
	"accordion__item": `FAQ_accordion__item__IGLZY`,
	"accordion__text": `FAQ_accordion__text__qRT5l`,
	"text__block": `FAQ_text__block__2PdcG`,
	"text__box": `FAQ_text__box__IsJ2P`,
	"block__title": `FAQ_block__title__h-qpo`
};
export default ___CSS_LOADER_EXPORT___;
